<template>
    <div class="r_edit_content" v-loading="formLoading">
        <!-- 基础信息 -->
        <div class="f_form_btn">
            <p class="r_edit_title">基础信息</p>
        </div>
        <div class="r_basic_content">
            <div class="r_basic_box">
                <div class="r_basic_left">
                    <!-- 个人基本信息展示模块 -->
                    <div class="r_lefts">
                        <div class="r_left_pic">
                            <el-image class="pic_item" :src="!isNull(basicQuery.Stravatar)?basicQuery.Stravatar:basicQuery.BolUserSex=='女'?womanStravatar:manStravatar" fit="contain"></el-image>
                        </div>
                        <div class="r_left_info">
                            <div class="r_qiwei">
                                <p>{{basicQuery.StrUserName}}</p>
                                <el-image v-if="basicQuery.StrIsqwfri == '是'" :src="urlWechat" fit="cover"></el-image>
                            </div>
                            <!-- <p class="r_txts">{{basicQuery.StrState}}</p> -->
                            <p class="r_txts">
                                <span class="r_txt01">{{basicQuery.StrEduLvl}}</span>
                                <span class="r_txt01">{{basicQuery.BolUserSex}}</span>
                                <span class="r_txt01">{{basicQuery.StrUsernation}}</span>
                                <span class="r_txt02" v-if="!isNull(basicQuery.StrUserAge)">{{basicQuery.StrUserAge}}岁</span>
                            </p>
                            <p class="r_txts" v-if="!isNull(basicQuery.StrUserAdd)">
                                <span class="r_txt01">居住地</span>
                                <span class="r_txt03">{{basicQuery.StrUserAdd}}</span>
                            </p>
                        </div>
                        <div class="r_left_info">
                            <p class="r_txts" v-if="!isNull(basicQuery.StrMobile)" style="margin-top: 0;">
                                <i class="el-icon-phone"></i>
                                <span class="r_txt04">{{basicQuery.StrMobile}}</span>
                            </p>
                            <p class="r_txts r_txts01">
                                <span class="r_txt01">黑名单</span>
                                <span class="r_txt01">{{isNull(basicQuery.StrIsBlack)?'否':basicQuery.StrIsBlack}}</span>
                            </p>
                            <p class="r_txts r_txts01" v-if="basicQuery.StrIsBlack == '是'">
                                <span class="r_txt01 com_title">黑名单原因</span>
                                <span class="r_txt01">{{basicQuery.StrBlackReason}}</span>
                            </p>
                            <p class="r_txts" v-if="!isNull(basicQuery.Strother)">
                                <span class="r_txt01">政治面貌</span>
                                <span class="r_txt03">{{basicQuery.Strother}}</span>
                            </p>
                            <p class="r_txts" v-if="!isNull(basicQuery.StrNativePlace)">
                                <span class="r_txt01">籍贯</span>
                                <span class="r_txt03">{{basicQuery.StrNativePlace}}</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="r_basic_right" v-if="isDetail">
                    <!-- <p class="r_txt04">{{basicQuery.StrWorkState}}</p> -->
                    <p class="r_txt04">在职</p>
                    <!-- <p class="r_txt05">{{basicQuery.DtupdateDate}}</p> -->
                </div>
            </div>
            <!-- 标签 -->
            <div class="r_label_box">
                <div class="r_label_left">
                    <div class="l_box">
                        <div class="r_label_list">
                            <div class="r_label_item" v-for="(item,index) in lPubDialogList" :key="index">{{item.LableName}}</div>
                            <div class="r_label_item" v-for="(item,index) in lPriDialogList" :key="index">{{item.LableName}}</div>
                            <!-- <i class="el-icon-circle-plus-outline icon_add" title="更新标签" @click="addLabelHandle"></i> -->
                        </div>
                    </div>
                </div>
                <div class="r_label_right">
                    <p class="r_txt06" v-if="!isNull(basicQuery.StrSource)">
                        <span class="r_txt01">简历来源:</span>
                        <span>{{basicQuery.StrSource}}</span>
                    </p>
                    <p class="r_txt06" v-if="!isNull(basicQuery.enterUser)">
                        <span class="r_txt01">简历创建人</span>
                        <span>{{basicQuery.enterUser}}</span>
                    </p>
                    <p class="r_txt05">{{isNull(basicQuery.enterDate)?'':basicQuery.enterDate.replace('T',' ')}}</p>
                </div>
            </div>
        </div>
        <!-- 在职项目 -->
        <div class="f_form_btn">
            <p class="r_edit_title">在职项目</p>
        </div>
        <div class="r_spend_box">
            <!-- <div class="r_btn_box">
                <el-button v-if="!isDetail" type="primary" size="mini" @click="addJobHandle">新增在职项目</el-button>
            </div> -->
            <el-table :data="onJobData" style="width: 100%" class="in_table_box">
                <el-table-column prop="StrBusitypeName" align="center" label="业务类型" fit :show-overflow-tooltip="true" min-width="110px"></el-table-column>
                <el-table-column prop="LaborRelation" align="center" label="劳动关系" fit :show-overflow-tooltip="true" min-width="110px"></el-table-column>
                <el-table-column prop="StrprojectName" align="center" label="项目" fit :show-overflow-tooltip="true" min-width="110px"></el-table-column>
                <el-table-column prop="JobCategory" align="center" label="岗位" fit :show-overflow-tooltip="true" min-width="110px"></el-table-column>
                <el-table-column prop="Strworkviewadd" align="center" label="入职地点" fit :show-overflow-tooltip="true" min-width="110px"></el-table-column>
                <el-table-column prop="DtInducttime" align="center" label="入职时间" fit :show-overflow-tooltip="true" min-width="150px">
                    <template slot-scope="{row}">
                        <span>{{ isNull(row.DtInducttime) ? '' : row.DtInducttime.replace('T',' ')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Strworkday" align="center" label="已在职天数" fit :show-overflow-tooltip="true" min-width="110px"></el-table-column>
                <el-table-column prop="PayDate" align="center" label="发薪日" min-width="90px"></el-table-column>
                <el-table-column prop="GduserName" align="center" label="招聘顾问" fit :show-overflow-tooltip="true" min-width="100px"></el-table-column>
                <el-table-column prop="Usernamekf" align="center" label="服务客服" fit :show-overflow-tooltip="true" min-width="100px"></el-table-column>
                <!-- <el-table-column min-width="110" align="center" prop="address" label="操作" v-if="!isDetail">
                    <template scope="{row}">
                        <el-button type="danger" size="mini" @click="dltAllHandle(row.Streduid,'edu')">删除</el-button>
                    </template>
                </el-table-column> -->
            </el-table>
        </div>
        <!-- 在职资料(招聘不能修改) -->
        <div class="f_form_btn" v-if="checkPermission(['signupList_edit_jobinfo'],permissionLists)">
            <p class="r_edit_title">在职资料</p>
            <div class="r_title_btns">
                <!-- <el-button type="info" size="small" @click="isDetail = true">取消</el-button> -->
                <el-button v-if="editTxt == '编辑'" type="primary" size="small" @click="editHandle">编辑</el-button>
                <el-button v-if="editTxt == '保存编辑'" type="primary" @click="saveHandle" size="small">保存编辑</el-button>
            </div>
        </div>
        <div class="r_spend_box" v-if="checkPermission(['signupList_edit_jobinfo'],permissionLists)">
            <!-- 在职资料展示模块 -->
            <div class="i_info_box" v-if="isDetail">
                <div class="i_info_list">
                    <div class="i_info_item">
                        <div class="i_info_left">姓名</div>
                        <div class="i_info_right">{{empInfoData.StrEmpName}}</div>
                    </div>
                    <div class="i_info_item">
                        <div class="i_info_left">紧急联系人</div>
                        <div class="i_info_right">{{empInfoData.StrContName}}</div>
                    </div>
                    <div class="i_info_item">
                        <div class="i_info_left">联系方式</div>
                        <div class="i_info_right">{{empInfoData.StrPhoneNum}}</div>
                    </div>
                    <div class="i_info_item">
                        <div class="i_info_left">身份证</div>
                        <div class="i_info_right">{{empInfoData.StrIdCard}}</div>
                    </div>
                    <div class="i_info_item">
                        <div class="i_info_left">银行卡号</div>
                        <div class="i_info_right">{{empInfoData.StrBankCard}}</div>
                    </div>
                    <div class="i_info_item">
                        <div class="i_info_left">银行</div>
                        <div class="i_info_right">{{empInfoData.StrBankName}}</div>
                    </div>
                </div>
            </div>
            <!-- 在职资料编辑模块 -->
            <el-form v-if="!isDetail" :inline="true" :rules="empInfoRules" ref="empInfoForm" :model="empInfoData" class="re_dtl_form re_dtl_form01" label-width="90px">
                <el-form-item label="姓名:" prop="StrEmpName">
                    <el-input v-model="empInfoData.StrEmpName" size="small" clearable></el-input>
                </el-form-item>
                <el-form-item label="紧急联系人:" prop="StrContName">
                    <el-input v-model="empInfoData.StrContName" size="small" clearable></el-input>
                </el-form-item>
                <!-- <el-form-item label="婚姻状况:" prop="StrMobile">
                    <el-select v-model="basicQuery.BolUserSex" placeholder="" size="small">
                        <el-option label="女" value="女"></el-option>
                        <el-option label="男" value="男"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="联系方式:" prop="StrPhoneNum">
                    <el-input v-model="empInfoData.StrPhoneNum" size="small" disabled clearable></el-input>
                </el-form-item>
                <el-form-item label="身份证:" prop="StrIdCard">
                    <el-input v-model="empInfoData.StrIdCard" size="small" disabled clearable></el-input>
                </el-form-item>
                <!-- <el-form-item label="身份证过期提醒:" prop="StrMobile">
                    <el-input v-model="empInfoData.StrMobile" size="small" clearable></el-input>
                </el-form-item> -->
                <el-form-item label="银行卡号:" prop="StrBankCard">
                    <el-input v-model="empInfoData.StrBankCard" size="small" clearable></el-input>
                </el-form-item>
                <el-form-item label="银行:" prop="StrBankName">
                    <el-input v-model="empInfoData.StrBankName" size="small" clearable></el-input>
                </el-form-item>
            </el-form>
        </div>
        <!-- 其他信息 -->
        <div class="f_form_btn" v-if="checkPermission(['signupList_edit_jobinfo'],permissionLists)">
            <p class="r_edit_title">其他信息</p>
        </div>
        <div class="r_spend_box" v-if="checkPermission(['signupList_edit_jobinfo'],permissionLists)">
            <!-- <div class="r_btn_box">
                <el-button v-if="!isDetail" type="primary" size="mini" @click="addContractHandle">更新合同类型</el-button>
            </div> -->
            <el-table :data="contractList" style="width: 100%" class="in_table_box">
                <el-table-column prop="StrContractType" label="合同协议类型" min-width="110px"></el-table-column>
                <el-table-column prop="DtContractBtime" label="劳动合同起始时间" min-width="110px">
                    <template slot-scope="{row}">
                        <span>{{!isNull(row.DtContractBtime)?row.DtContractBtime.substring(0,10):''}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="DtContractTime" label="劳动合同到期时间" min-width="110px">
                    <template slot-scope="{row}">
                        <span>{{!isNull(row.DtContractTime)?row.DtContractTime.substring(0,10):''}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 新增表单 -->
            <div class="r_spend_form" v-if="!isDetail">
                <div class="s_content">
                    <div class="r_spend_item01">
                        <el-select v-model="empInfoData.StrContractType" placeholder="请选择合同协议类型" size="small" class="s_input">
                            <el-option v-for="item in contractTypeList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
                        </el-select>
                        <el-date-picker v-model="empInfoData.DtContractBtime" value-format="yyyy-MM-dd" size="small" type="date" placeholder="劳动合同起始时间" class="s_input"></el-date-picker>
                        <el-date-picker v-model="empInfoData.DtContractTime" value-format="yyyy-MM-dd" size="small" type="date" placeholder="劳动合同到期时间"></el-date-picker>
                        <!-- <i class="el-icon-delete-solid dlt_icon" title="删除" @click="dltSpendHandle('contract')"></i> -->
                        <!-- <i class="el-icon-circle-check dlt_icon" title="更新" @click="saveHandle('one')"></i> -->
                    </div>
                </div>
            </div>
            <!-- <div class="r_btn_box">
                <el-button v-if="!isDetail" type="primary" size="mini" @click="addPhysicalHandle">更新体检类型</el-button>
            </div> -->
            <el-table :data="physicalList" style="width: 100%" class="in_table_box">
                <el-table-column prop="StrPetype" label="体检类型" min-width="110px"></el-table-column>
                <el-table-column prop="StrPeres" label="体检结果" min-width="110px"></el-table-column>
            </el-table>
            <!-- 新增表单 -->
            <div class="r_spend_form" v-if="!isDetail">
                <div class="s_content">
                    <div class="r_spend_item01">
                        <el-select filterable v-model="empInfoData.StrPetype" clearable placeholder="请选择体检类型" size="small" class="s_input">
                            <el-option label="无要求" value="无要求"></el-option>
                            <el-option label="常规体检" value="常规体检"></el-option>
                            <el-option label="职业病体检" value="职业病体检"></el-option>
                        </el-select>
                        <el-input v-model="empInfoData.StrPeres" placeholder="请输入体检结果" size="small" clearable class="s_input"></el-input>
                        <!-- <el-date-picker v-model="empInfoData.DtContractBtime" type="date" placeholder="体检时间"></el-date-picker> -->
                        <!-- <i class="el-icon-delete-solid dlt_icon" title="删除" @click="dltSpendHandle('physical')"></i> -->
                        <!-- <i class="el-icon-circle-check dlt_icon" title="更新" @click="saveHandle('one')"></i> -->
                    </div>
                </div>
            </div>
            <!-- <div class="r_btn_box">
                <el-button v-if="!isDetail" type="primary" size="mini" @click="addInsurHandle">更新商保类型</el-button>
            </div> -->
            <el-table :data="insurList" style="width: 100%" class="in_table_box">
                <el-table-column prop="StrInsuranceType" label="参保种类" min-width="110px"></el-table-column>
                <el-table-column prop="DtInsuranceDate" label="参保日期" min-width="110px">
                    <template slot-scope="{row}">
                        <span>{{!isNull(row.DtInsuranceDate)?row.DtInsuranceDate.substring(0,10):''}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="StrMedicalCard" label="医保卡号" min-width="110px"></el-table-column>
            </el-table>
            <!-- 新增表单 -->
            <div class="r_spend_form" v-if="!isDetail">
                <div class="s_content">
                    <div class="r_spend_item01">
                        <el-input v-model="empInfoData.StrInsuranceType" placeholder="请输入参保种类" size="small" clearable class="s_input"></el-input>
                        <el-date-picker v-model="empInfoData.DtInsuranceDate" value-format="yyyy-MM-dd" size="small" type="date" placeholder="参保日期" class="s_input"></el-date-picker>
                        <el-input v-model="empInfoData.StrMedicalCard" placeholder="请输入医保卡号" size="small" clearable class="s_input"></el-input>
                        <!-- <i class="el-icon-delete-solid dlt_icon" title="删除" @click="dltSpendHandle('insur')"></i> -->
                        <!-- <i class="el-icon-circle-check dlt_icon" title="更新" @click="saveHandle('one')"></i> -->
                    </div>
                </div>
            </div>
        </div>
        <!-- 工伤记录 -->
        <div class="f_form_btn" v-if="checkPermission(['signupList_edit_jobinfo'],permissionLists)">
            <p class="r_edit_title">工伤记录</p>
        </div>
        <div class="r_spend_box" v-if="checkPermission(['signupList_edit_jobinfo'],permissionLists)">
            <!-- <div class="r_btn_box">
                <el-button v-if="!isDetail" type="primary" size="mini" @click="addInjuryHandle">更新工伤记录</el-button>
            </div> -->
            <el-table :data="injuryList" style="width: 100%" class="in_table_box">
                <el-table-column prop="StrDisabilityLevel" label="伤残等级" min-width="110px">
                </el-table-column>
                <el-table-column min-width="110" label="工伤发生时间">
                    <template slot-scope="{row}">
                        <span>{{!isNull(row.DtInjuryBdate)?row.DtInjuryBdate.substring(0,10):''}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 新增表单 -->
            <div class="r_spend_form" v-if="!isDetail">
                <div class="s_content">
                    <div class="r_spend_item01">
                        <el-select v-model="empInfoData.StrDisabilityLevel" size="small" placeholder="请选择伤残等级" clearable class="s_input">
                            <el-option value="一级"></el-option>
                            <el-option value="二级"></el-option>
                            <el-option value="三级"></el-option>
                            <el-option value="四级"></el-option>
                            <el-option value="五级"></el-option>
                            <el-option value="六级"></el-option>
                            <el-option value="七级"></el-option>
                            <el-option value="八级"></el-option>
                            <el-option value="九级"></el-option>
                            <el-option value="十级"></el-option>
                            <el-option value="无等级"></el-option>
                            <el-option value="工亡"></el-option>
                        </el-select>
                        <el-date-picker v-model="empInfoData.DtInjuryBdate" value-format="yyyy-MM-dd" type="date" placeholder="工伤发生时间" size="small"></el-date-picker>
                        <!-- <i class="el-icon-delete-solid dlt_icon" title="删除" @click="dltSpendHandle('injury')"></i> -->
                        <!-- <i class="el-icon-circle-check dlt_icon" title="更新" @click="saveHandle('one')"></i> -->
                    </div>
                </div>
            </div>
        </div>
        <!-- 添加标签弹框 -->
        <el-dialog title="编辑标签" :visible.sync="addlabelVisible" width="700px" class="res_dialog">
            <div class="r_label_box" v-loading="laloading">
                <el-tabs v-model="labelActiveName" @tab-click="handleLabelClick">
                <el-tab-pane label="全局标签" name="全局标签">
                    <div class="dia_label_box">
                    <div class="dia_label_item" v-for="item in publicList" :key="item.LbGroup.Id">
                        <div class="dia_groupname">{{item.LbGroup.LableName}}</div>
                        <el-checkbox-group v-model="wholeCheckList" @change="dPubEnterHandle">
                            <el-checkbox v-for="(lab,index) in item.LbGroupVallist" border :label="lab.Id" :key="index">
                            <span v-if="lab.IsEnable">{{lab.LableName}}</span>
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                    </div>
                </el-tab-pane>
                <!-- <el-tab-pane label="私人标签" name="私人标签">
                    <div class="dia_label_box">
                    <div class="dia_label_item" v-for="item in privateList" :key="item.LbGroup.Id">
                        <div class="dia_groupname">{{item.LbGroup.LableName}}</div>
                        <el-checkbox-group v-model="wholeCheckList2" @change="dPraEnterHandle">
                            <el-checkbox v-for="(lab,index) in item.LbGroupVallist" border :label="lab.Id" :key="index">
                            <span v-if="lab.IsEnable">{{lab.LableName}}</span>
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                    </div>
                </el-tab-pane> -->
                </el-tabs>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button
                @click="addlabelVisible = false"
                size="small"
                >取消</el-button>
                <el-button type="primary"
                @click="saveLabelHandle"
                size="small"
                >保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>
  
<script>
import xz from "./../../../common";
import checkPermission from '@/utils/permission' // 权限判断函数
import moment from 'moment'
export default {
    data() {
        var validatePhone = (rule, value, callback) => {
            const phoneReg = /^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/i;
            // console.log('validatePhone',value)
            if (value.length == 11 && phoneReg.test(value)) {
                //校验通过
                callback()
            } else {
                callback(new Error('请输入正确的手机号'))
            }
        }
        return {
            // 默认头像
            defaultPic: require(("./../../../assets/images/psn.png")),
            manStravatar:"https://devltapp.joball.net/cloudimg/" + '/images/man.jpg',
            womanStravatar:"https://devltapp.joball.net/cloudimg/" + '/images/woman.jpg',
            // 简历来源
            originList:[],
            idcard:'',
            //学历要求
            eduList: [],
            // 录入简历参数
            basicQuery:{
                natureId:'', //自然人ID
                ResumeId: '', //简历ID
                StrUserName: '', //姓名
                StrMobile: '', //联系方式
                StrWorkState: '', //在离职状态
                BolUserSex: '', //性别
                StrUserAge: '', //年龄
                StrNativePlace: '', //户籍
                StrEduLvl: '', //学历
                StrJobInf: '', //意向岗位
                StrCategoryIds: '', //意向岗位id
                // 选中的意向岗位
                posCategoryList: [],
                StrUserCity: '', //求职城市
                StrUserAdd: '', //居住地
                StrUserCityCode: '', //求职城市code
                StrSource: '', //来源
                StrUserExpectSa: '', //期望薪资
                salary1: '',
                salary2: '',
                StrRemark: '', //备注
                StrlateCompany: '', //最近入职项目
                DtlateInducDate: '', //最近入职时间
                DtlatequitDate: '', //最近离职时间
                StrquitReason: '', //离职原因
                StrUserJobhunt: '', //求职意向
                StrPsnIsType: '', //是否公海 1 公海 0私人
                enterUser:'', //录入人
                enterDate:'', //录入时间
                StrJobType:'', //岗位类型
                StrState:'', //状态
                DtupdateDate:'',//最新更新时间
                //拓展
                StrIsBlack: '', //是否黑名单
                StrBlackReason: '', //黑名单原因
                StrUsernation: '', //民族
                Strskill: '', //技能
                Strcertificate: '', //证书
                StrAccomreq: '', //住宿要求
                StrDinreq: '', //吃饭要求
                StrIsqwfri: '', //是否企微好友
                StrCont1: '', //拓展1
                StrCont2: '',
                StrCont3: '',
                StrCont4: '',
                StrCont5: '',
                StrCont6: '',
                StrCont7: '',
                StrCont8: '',
                StrCont9: '',
                StrCont10: '',
                Strsocial:'',//社保需求
                Strother:'', // 政治面貌
                WorkingShift: '', // 班次
                Workingposition: '', // 站班/坐班
                StrResumefile:'', // 简历文件名称
                StrResumefileUrl:'' // 简历文件路径
            },
            // 标签弹框公有标签列表
            lPubDialogList:[],
            // 标签弹框私有标签列表
            lPriDialogList:[],
            // 添加标签弹框选中的标签
            diaTagChecks:[],
            // 自定义 级联选择props
            propPosition: { label: 'strParametername', value: 'strParameterid', children: 'children', checkStrictly: true },
            // 规则
            basicRules: {
                StrUserName: [
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                StrMobile: [
                    { required: true, message: '请输入联系方式', trigger: 'blur' },
                    { validator: validatePhone, trigger: ['blur'] }
                ],
                StrUserCity: [
                    { required: true, message: '请选择意向地区', trigger: 'change' }
                ],
                posCategoryList: [
                    { type: 'array', required: true, message: '请选择意向岗位', trigger: 'change'}
                ],
                StrUserAge: [
                    { required: true, message: '请输入年龄', trigger: 'blur' }
                ]
            },
            empInfoRules:{},
            // 编辑按钮文字
            editTxt:'编辑',
            isDetail: true,
            urlWechat: require("./../../../assets/images/qwei.png"),
            addlabelVisible: false,
            laloading: false,
            // 全局标签
            publicList: [],
            // 私人标签
            privateList: [],
            // 弹框选中的全局标签
            dCheckCommonLabelList:[],
            // 弹框选中的私有标签
            dCheckPriLabelList:[],
            postList: [],
            // 选中的地区code
            strCityCode: '',
            // 意向岗位列表
            intendedPost: [],
            // 社保需求列表
            socialList:['需要','不需要'],
            labelActiveName: '全局标签',
            // 省份
            provinces: [],
            propsAddress: {
                lazy: true,
                checkStrictly: true,
                value: 'Id',
                label: 'Name',
                lazyLoad(node, resolve) {
                const { value, level } = node;
                if (value && value != undefined) {
                    xz.getArea(value).then(res => {
                    if (res.status == 'ok') {
                        if (level === 2) {
                        resolve(
                            res.data.ret.map(item => {
                            item.leaf = 'leaf'
                            return item
                            })
                        )
                        } else {
                        resolve(res.data.ret)
                        }
                    } else {
                        this.$message.error('获取城市出错')
                    }
                    })
                }
                }
            },
            addlabelVisible: false,
            roleType: '',
            wholeCheckList: [],
            wholeCheckList2: [],
            // 合同协议类型
            contractTypeList: [],
            // 在职项目列表
            onJobData: [],
            // 新增的在职项目列表
            onJobList: [],
            // 合同类型列表
            contractList:[],
            addContractList:[],
            // 体检类型列表
            physicalList:[],
            addPhysicalList:[],
            // 商保类型列表
            insurList:[],
            // 工伤记录列表
            injuryList:[],
            // 删除参数
            dltQuery:{
                strid:'',
                strtype:'' //kill  技能  edu 教育  work 工作
            },
            formLoading:false,
            // 在职信息
            empInfoData:{
                StrObjName:'', //项目名称
                IntSerialNumber:'', //序号
                StrTmpProject:'', //自定义项目1
                StrDepName:'', //部门
                StrJobInf:'', //岗位
                StrEmpName:'', //姓名
                StrIdCard:'', //身份证号码
                StrPolitical:'', //政治面貌
                DtIcCareEdate:'', //身份证有效终止时间
                StrCityzenType:'', //户粮
                StrPhoneNum:'', //联系方式
                StrContName:'', //紧急联系人
                StrContTel:'', //紧急联络方式
                StrNationClass:'', //民族
                StrNativePlace:'', //籍贯
                StrNativeAddr:'', //户籍地址
                StrAddr:'', //现住地址
                StrEduLv:'', //教育程度
                StrInsuranceType:'', //参保种类
                DtInsuranceDate:'', //参保日期
                StrMedicalCard:'', //医保卡号
                DtEntryBdate:'', //用工之日
                StrContractType:'', //合同（协议）类型
                IntContractNum:'', //签定合同次数
                StrContractBedate:'', //签订合同起止时间记录
                DtProbationEdate:'', //试用期到期日期
                DtContractBtime:'', //劳动合同起始时间
                DtContractTime:'', //劳动合同到期时间
                StrWorkState:'', //在/离职状态
                StrBankCard:'', //银行卡号
                StrBankName:'', //银行
                StrWithdrawal:'', //计提
                StrInCity:'', //招聘岗位类别
                StrOutsideCity:'', //招聘岗位
                StrOther:'', //临时工
                StrPetype:'', //体检类型
                StrPeres:'', //体检结果
                StrEmpUsrStatus:'', //人员状态
                DtInjuryBdate:'', //工伤发生时间
                StrDisabilityLevel:'', //伤残等级
                DtInjuryEdate:'', //自定义项目5
                StrBlacklist:'', //是否黑名单
                StrBlacklistReason:'', //黑名单原因
                StrRemark:'', //备注
                qudao:'',//招聘渠道
                sctjr:'', //社招推荐人
                gsqd:'', //公司渠道
                gsqdtjr:'', //公司渠道推荐人
                wbqd:'', //外部渠道
                wbqdtjr:'', //外部渠道推荐人
                qtqk:'' //其他情况
            },
            injuryVisible:false,
            insurVisible:false,
            physicalVisible:false,
            contractVisible:false,
            // 政治面貌
            politicsList:[],
            // 民族
            nationList: [],
            processQuery:{
                Jobid:'', //岗位id
                Projectid:'', //项目id
                ResumeId:'',//简历ID
                StrState:'入职',//当前状态
                StrRemark:'',//否决原因 离职原因等
                Dtviewtime:'',//面试时间
                Strviewadd:'',//面试地址
                Dtreachtime:'',//预计到岗时间
                DtInducttime:'',//入职时间
                StrIsphysical:'',//是否体检
                Strphysicalhos:'',//体检医院
                Dtquittime:'',//离职时间
                Strquittype:'',//离职类型
                StrIsBlack:'',//是否黑名单
                StrBlacklabel:'',//黑名单标签
                StrWorkAddress:'',//入职地址
                StrIdCard:''//身份证号码
            },
            loginRoleType:'',
            // 按钮权限参数
            butQuery:{
                path:'/signupList',
                powerEnName:'employee'
            },
            permissionLists:[]
        }
    },
    created() {
        this.loginRoleType = localStorage.loginRoletype
        this.basicQuery.ResumeId = this.$route.query.id
        this.getButtonPower()//获取按钮权限
        // 获取省份
        this.getprovinces(0)
        // 获取详情
        this.getResumeDtl(this.basicQuery.ResumeId)
         // 获取标签详情
        this.getresumelabelLists(this.basicQuery.ResumeId)
        this.getdictdatalistbyid('70')
        // 民族
        this.getdictdatalistbyid('153')
        // 政治面貌
        this.getdictdatalistbyid('160')
        // 简历来源
        this.getdictdatalistbyid('118')
        // 学历要求
        this.getdictdatalistbyid('141')
        // 合同协议类型
        this.getdictdatalistbyid('174')
    },
    methods:{
        // 保存
        saveHandle(){
            // console.log('保存', this.empInfoData,this.processQuery)
            let that = this
            // this.$refs['enterResumeForm'].validate((valid) => {
            //     if (valid) {
                    // xz.inducEmpData(that.empInfoData).then(res => {
                    //     // console.log('saveEnterHandle', res)
                    //     if (res.status == 'ok') {
                            xz.broleInducEmpData(that.empInfoData).then(ele => {
                                if (ele.status == 'ok') {
                                    this.$message({ type: 'success', message: '操作成功' })
                                    this.getResumeDtl(this.basicQuery.ResumeId);
                                    this.isDetail = true;
                                    this.editTxt = '编辑';
                                }else{
                                    this.$message({ type: 'error', message: '操作失败，请稍后再试' })
                                }
                            })
                        // }else{
                        //     this.$message({ type: 'error', message: res.msg })
                        // }
                //     })
                // } else {
                //     return false;
                // }
            // })
        },
        checkPermission,
        // 获取按钮权限
        getButtonPower(){
            xz.getbtnPowerIdBypage(this.butQuery).then(res => {
                // console.log('按钮',res)
                if(res.status == 'ok'){
                let resmsg = res.msg
                if(!this.isNull(resmsg)){
                    for (let index = 0; index < resmsg.length; index++) {
                    let element = resmsg[index];
                    this.permissionLists.push(element.Enname);
                    }
                }else{
                    this.permissionLists = []
                }
                }else{
                this.permissionLists = []
                }
            })
        },
        // 新增合同类型
        addContractHandle(){
            this.contractVisible = true
        },
        // 新增体检类型
        addPhysicalHandle(){
            this.physicalVisible = true
        },
        // 新增商保类型
        addInsurHandle(){
            this.insurVisible = true
        },
        // 新增工伤记录
        addInjuryHandle(){
            this.injuryVisible = true
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择上传 1 个文件`);
        },
        // 删除
        dltSpendHandle(type,data,index){
            // data.splice(index, 1)
            if(type == 'contract'){
                this.contractVisible = false
                this.empInfoData.StrContractType= ''
                this.empInfoData.DtContractBtime= ''
                this.empInfoData.DtContractTime= ''
            }
            if(type == 'physical'){
                this.physicalVisible = false
                this.empInfoData.StrContractType= ''
                this.empInfoData.StrPeres= ''
            }
            if(type == 'insur'){
                this.insurVisible = false
                this.empInfoData.StrInsuranceType= ''
                this.empInfoData.DtInsuranceDate= ''
                this.empInfoData.StrMedicalCard= ''
            }
            if(type == 'injury'){
                this.injuryVisible = false
                this.empInfoData.StrDisabilityLevel= ''
                this.empInfoData.DtInjuryBdate= ''
            }
        },
        // 证书上传附件
        handleReceiptChange(file, fileList, index) {
            // empexcel 对应 Excel  // docinf
            // bdocinf     对应 doc/pdf等
            // entimg      对应 图片类
            // usrvidoe   对应 视频类
            let formData = new FormData()
            formData.append("action", 'save')
            formData.append("pagename", 'bdocinf')
            formData.append("userid", Cookies.get("userid-b"))
            formData.append("entid", Cookies.get("userid-b"))
            formData.append("entPicFile", file.raw, file.name)
            this.certList[index].fileReceiptList = fileList
            // this.gapQuery.StrEnclosureName = file.name
            console.log('entPicFile', file, this.fileReceiptList)
            xz.uploadCert(formData).then(res => {
                // console.log('entPicFile', res)
                if (res) {
                this.certList[index].Enclosure = res
                } else {
                this.$message('文件上传失败,请稍后再试')
                }
            })
        },
        handleReceiptRemove(file, fileList, index) {
            this.certList[index].Enclosure = ''
            this.certList[index].fileReceiptList = fileList
            // console.log('file', this.infoList)
        },
        // 保存标签
        saveLabelHandle(){
            this.diaTagChecks = this.dCheckPriLabelList.concat(this.dCheckCommonLabelList)
            //去重
            this.diaTagChecks = [...new Set(this.diaTagChecks)];
            let ids = this.diaTagChecks.toString()
            // console.log('uuu',this.basicQuery.ResumeId, ids)
            if(this.isNull(this.diaTagChecks)){
                this.$message({ type: 'warning', message: '请选择标签' })
                return false
            }else{
                this.tagHandle({resumeIds:this.basicQuery.ResumeId,labelIds:ids})
            }
        },
        // 打标签
        tagHandle(query){
            // console.log('tagHandle', query)
            xz.savelabelResume(query).then(res => {
                // console.log('tagHandle', res)
                if (res.status == 'ok') {
                this.addlabelVisible = false
                this.getresumelabelLists(this.basicQuery.ResumeId)
                this.$message({ type: 'success', message: '操作成功' })
                }else{
                this.$message({ type: 'error', message: '操作失败,请稍后再试' })
                }
            })
        },
        handleLabelClick(tab){},
         // 标签弹框 选择公有标签
        dPubEnterHandle(val){
            this.dCheckCommonLabelList = []
            // console.log('labelEnterHandle', val)
            this.dCheckCommonLabelList = val
        },
        // 标签弹框 选择私有标签
        dPraEnterHandle(val){
            this.dCheckPriLabelList = []
            // console.log('lPraEnterHandle', val)
            this.dCheckPriLabelList = val
        },
        // 添加标签弹框
        addLabelHandle(){
            this.GetLabelManagement()
            // 全局标签
            for (let i = 0; i < this.lPubDialogList.length; i++) {
                const elementl1 = this.lPubDialogList[i];
                this.wholeCheckList.push(elementl1.LabelId)
            }
            // 私有
            for (let j = 0; j < this.lPriDialogList.length; j++) {
                const elementl2 = this.lPriDialogList[j];
                this.wholeCheckList2.push(elementl2.LabelId)
            }
            this.dCheckPriLabelList = this.wholeCheckList2
            this.dCheckCommonLabelList = this.wholeCheckList
            this.diaTagChecks = this.wholeCheckList.concat(this.wholeCheckList2)
            this.addlabelVisible = true
        },
        // 点击更换头像
        handleAvatarSuccess(res, file) {
            // console.log('file', res, file)
            // 连接后台服务器
            // this.staffQuery.imageUrl = URL.createObjectURL(file.raw)
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === "image/jpeg"
            const isLt2M = file.size / 1024 / 1024 < 2
            //   if (!isJPG) {
            //     this.$message.error("上传头像图片只能是 JPG 格式!")
            //   }
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 2MB!")
            }
            //  return isJPG && isLt2M
             return isLt2M
        },
        upLoad(file) {
            // 通过form数据格式来传
            const formData = new FormData()
            // formData.append("file", file)
            formData.append('userid', Cookies.get('userid-b'))
            formData.append('entid', Cookies.get('userid-b'))
            formData.append('pagename', 'entimg')
            formData.append('action', 'save')
            formData.append("entPicFile", file.raw, file.name)
            // 此时的formData可通过formData.get("file_name")查看添加的参数
            // console.log("file_name",formData.get("file"))
            uploadAvatar(formData).then((res) => {
                // console.log(res)
                if (res) {
                this.staffQuery.Stravatar = res
                } else {
                this.$message('头像上传失败,请稍后再试')
                }
            })            
        },
        // 返回
        backHandle(){
            this.$router.back()
            // this.$router.go(-1) // 后退+刷新
        },
        // 编辑
        editHandle(){
            this.isDetail = !this.isDetail
            if(this.isDetail){
                this.editTxt = '编辑'
            }else{
                this.editTxt = '保存编辑'
            }
        },
        // 获取简历详情
        getResumeDtl(id){
            xz.getResumeDetail({ResumeId: id}).then(res => {
                // console.log('getResumeDtl', res)
                if (res.status == 'ok') {
                    let resMsg = res.msg
                    let resMsgp = res.msgp
                    this.idcard = res.msg.StrIdCard
                    this.basicQuery = {
                        natureId:resMsgp.GdPsnId, //自然人ID GdPsnId
                        enterUser:resMsgp.Creator, // 录入人
                    ResumeId: resMsg.ResumeId, //简历ID
                    StrUserName: resMsg.StrUserName, //姓名
                    StrMobile: resMsg.StrMobile, //联系方式
                    StrWorkState: resMsg.StrWorkState, //在离职状态
                    BolUserSex: resMsg.BolUserSex, //性别
                    StrUserAge: resMsg.StrUserAge, //年龄
                    StrNativePlace: resMsg.StrNativePlace, //户籍
                    StrEduLvl: resMsg.StrEduLvl, //学历
                    StrJobInf: resMsg.StrJobInf, //意向岗位
                    StrCategoryIds: resMsg.StrCategoryIds, //意向岗位id
                    // 选中的意向岗位
                    posCategoryList: [],
                    StrUserCity: resMsg.StrUserCity, //求职城市
                    StrUserAdd: resMsg.StrUserAdd, //居住地
                    StrUserCityCode: resMsg.StrUserCityCode, //求职城市code
                    StrSource: resMsg.StrSource, //来源
                    StrUserExpectSa: resMsg.StrUserExpectSa, //期望薪资
                    salary1: !this.isNull(resMsg.StrUserExpectSa)?resMsg.StrUserExpectSa.split('-')[0]:'',
                    salary2: !this.isNull(resMsg.StrUserExpectSa)?resMsg.StrUserExpectSa.split('-')[1]:'',
                    StrRemark: resMsg.StrRemark, //备注
                    StrlateCompany: resMsg.StrlateCompany, //最近入职项目
                    DtlateInducDate: !this.isNull(resMsg.DtlateInducDate)?resMsg.DtlateInducDate:'', //最近入职时间
                    DtlatequitDate: !this.isNull(resMsg.DtlatequitDate)?resMsg.DtlatequitDate:'', //最近离职时间
                    StrquitReason: resMsg.StrquitReason, //离职原因
                    StrUserJobhunt: resMsg.StrUserJobhunt, //求职意向
                    StrPsnIsType: resMsg.StrPsnIsType, //是否公海 1 公海 0私人
                    enterDate: resMsg.DtInsertDate, //录入时间
                    StrJobType: resMsg.StrJobType, //岗位类型
                    StrState: resMsg.StrState, //状态
                    DtupdateDate: resMsg.DtupdateDate,
                    //拓展
                    StrIsBlack: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrIsBlack)?resMsgp.StrIsBlack:'', //是否黑名单
                    StrBlackReason: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrBlackReason)?resMsgp.StrBlackReason:'', //黑名单原因
                    StrUsernation: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrUsernation)?resMsgp.StrUsernation:'', //民族
                    Strskill: !this.isNull(resMsgp)&&!this.isNull(resMsgp.Strskill)?resMsgp.Strskill:'', //技能
                    Strcertificate: !this.isNull(resMsgp)&&!this.isNull(resMsgp.Strcertificate)?resMsgp.Strcertificate:'', //证书
                    StrAccomreq: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrAccomreq)?resMsgp.StrAccomreq:'', //住宿要求
                    StrDinreq: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrDinreq)?resMsgp.StrDinreq:'', //吃饭要求
                    StrIsqwfri: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrIsqwfri)?resMsgp.StrIsqwfri:'', //是否企微好友
                    StrCont1: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont1)?resMsgp.StrCont1:'', //拓展1
                    StrCont2: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont2)?resMsgp.StrCont2:'',
                    StrCont3: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont3)?resMsgp.StrCont3:'',
                    StrCont4: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont4)?resMsgp.StrCont4:'',
                    StrCont5: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont5)?resMsgp.StrCont5:'',
                    StrCont6: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont6)?resMsgp.StrCont6:'',
                    StrCont7: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont7)?resMsgp.StrCont7:'',
                    StrCont8: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont8)?resMsgp.StrCont8:'',
                    StrCont9: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont9)?resMsgp.StrCont9:'',
                    StrCont10: !this.isNull(resMsgp)&&!this.isNull(resMsgp.StrCont10)?resMsgp.StrCont10:'',
                    Strsocial:resMsgp.Strsocial,//社保需求
                    Strother:resMsgp.Strother, // 政治面貌
                    WorkingShift: resMsgp.WorkingShift, // 班次
                    Workingposition: resMsgp.Workingposition, // 站班/坐班
                    StrResumefile: resMsg.StrResumefile, // 简历附件名称
                    StrResumefileUrl: resMsg.StrResumefileUrl // 简历附件路径
                    }
                    this.strCityCode = resMsg.StrUserCityCode?resMsg.StrUserCityCode.split(','):[]
                    this.basicQuery.posCategoryList = resMsg.StrCategoryIds?resMsg.StrCategoryIds.split(','):[]
                    // console.log('iii', this.$refs[`cascaderArr`])
                    // if(!this.isNull(resMsg.StrUserCity)){
                    //     this.$nextTick(() => {this.$refs[`cascaderArr`].inputValue = resMsg.StrUserCity})
                    // }
                    // 获取在职信息
                    this.getempdetail(this.idcard)
                    // 在职信息列表
                    this.onJobData = this.isNull(res.msgonwork)?[]:[res.msgonwork[0]]
                    this.processQuery.Jobid = this.onJobData[0].Jobid
                    this.processQuery.Projectid = this.onJobData[0].Projectid
                    this.processQuery.ResumeId = this.onJobData[0].ResumeId
                    this.processQuery.StrWorkAddress = this.onJobData[0].Strworkviewadd
                    this.processQuery.DtInducttime = this.onJobData[0].DtInducttime
                    this.processQuery.StrIdCard = this.idcard
                    // console.log('saveEnterHandle', this.processQuery)
                }
            });
        },
        //参数列表（班次、坐班站班）
        getdictdatalistbyid(id) {
            xz.getdictdatalistbyid(id).then(res => {
                // console.log('getdictdatalistbyid', res)
                if (res.status == 'ok') {
                    if(id == '141'){
                        // 学历要求
                        this.eduList = res.data.retList
                    }
                    if(id == '153'){
                        // 民族
                        this.nationList = res.data.retList
                    }
                    if(id == '174'){
                        // 合同协议类型
                        this.contractTypeList = res.data.retList
                    }
                    if(id == '118'){
                        // 简历来源
                        this.originList = res.data.retList
                    }
                    if(id == '160'){
                        // 政治面貌
                        this.politicsList = res.data.retList
                    }
                }
            })
        },
        //获取在职资料
        getempdetail(idcard) {
            this.formLoading = true
            xz.getempdetail(idcard).then(res => {
                // console.log('idcard', res)
                if (res.status == 'ok') {
                    if(!this.isNull(res.msg)){
                        // 合同协议类型
                        if(this.isNull(res.msg[0].StrContractType)&&this.isNull(res.msg[0].DtContractBtime)&&this.isNull(res.msg[0].DtContractTime)){
                            this.contractList = []
                        }else{
                            this.contractList = [
                                {
                                    StrContractType:res.msg[0].StrContractType,
                                    DtContractBtime:res.msg[0].DtContractBtime,
                                    DtContractTime:res.msg[0].DtContractTime
                                }
                            ]
                        }
                        // 体检类型
                        if(this.isNull(res.msg[0].StrPetype)&&this.isNull(res.msg[0].StrPeres)){
                            this.physicalList = []
                        }else{
                            this.physicalList = [
                                {
                                    StrPetype:res.msg[0].StrPetype,
                                    StrPeres:res.msg[0].StrPeres
                                }
                            ]
                        }
                        // 参保种类
                        if(this.isNull(res.msg[0].StrInsuranceType)&&this.isNull(res.msg[0].DtInsuranceDate)&&this.isNull(res.msg[0].StrMedicalCard)){
                            this.insurList = []
                        }else{
                            this.insurList = [
                                {
                                    StrInsuranceType:res.msg[0].StrInsuranceType,
                                    DtInsuranceDate:res.msg[0].DtInsuranceDate,
                                    StrMedicalCard:res.msg[0].StrMedicalCard
                                }
                            ]
                        }
                        // 工伤记录
                        if(this.isNull(res.msg[0].StrDisabilityLevel)&&this.isNull(res.msg[0].DtInjuryBdate)){
                            this.injuryList = []
                        }else{
                            this.injuryList = [
                                {
                                    StrDisabilityLevel:res.msg[0].StrDisabilityLevel,
                                    DtInjuryBdate:res.msg[0].DtInjuryBdate
                                }
                            ]
                        }
                        // console.log('idcard', this.injuryList)
                        this.empInfoData = {
                            StrObjName:res.msg[0].StrObjName, //项目名称
                            IntSerialNumber:res.msg[0].IntSerialNumber, //序号
                            StrTmpProject:res.msg[0].StrTmpProject, //自定义项目1
                            StrDepName:res.msg[0].StrDepName, //部门
                            StrJobInf:res.msg[0].StrJobInf, //岗位
                            StrEmpName:res.msg[0].StrEmpName, //姓名
                            StrIdCard:res.msg[0].StrIdCard, //身份证号码
                            StrPolitical:res.msg[0].StrPolitical, //政治面貌
                            DtIcCareEdate:res.msg[0].DtIcCareEdate, //身份证有效终止时间
                            StrCityzenType:res.msg[0].StrCityzenType, //户粮
                            StrPhoneNum:res.msg[0].StrPhoneNum, //联系方式
                            StrContName:res.msg[0].StrContName, //紧急联系人
                            StrContTel:res.msg[0].StrContTel, //紧急联络方式
                            StrNationClass:res.msg[0].StrNationClass, //民族
                            StrNativePlace:res.msg[0].StrNativePlace, //籍贯
                            StrNativeAddr:res.msg[0].StrNativeAddr, //户籍地址
                            StrAddr:res.msg[0].StrAddr, //现住地址
                            StrEduLv:res.msg[0].StrEduLv, //教育程度
                            StrInsuranceType:res.msg[0].StrInsuranceType, //参保种类
                            DtInsuranceDate:res.msg[0].DtInsuranceDate, //参保日期
                            StrMedicalCard:res.msg[0].StrMedicalCard, //医保卡号
                            DtEntryBdate:res.msg[0].DtEntryBdate, //用工之日
                            StrContractType:res.msg[0].StrContractType, //合同（协议）类型
                            IntContractNum:res.msg[0].IntContractNum, //签定合同次数
                            StrContractBedate:res.msg[0].StrContractBedate, //签订合同起止时间记录
                            DtProbationEdate:res.msg[0].DtProbationEdate, //试用期到期日期
                            DtContractBtime:res.msg[0].DtContractBtime, //劳动合同起始时间
                            DtContractTime:res.msg[0].DtContractTime, //劳动合同到期时间
                            StrWorkState:res.msg[0].StrWorkState, //在/离职状态
                            StrBankCard:res.msg[0].StrBankCard, //银行卡号
                            StrBankName:res.msg[0].StrBankName, //银行
                            StrWithdrawal:res.msg[0].StrWithdrawal, //计提
                            StrInCity:res.msg[0].StrInCity, //招聘岗位类别
                            StrOutsideCity:res.msg[0].StrOutsideCity, //招聘岗位
                            StrOther:res.msg[0].StrOther, //临时工
                            StrPetype:res.msg[0].StrPetype, //体检类型
                            StrPeres:res.msg[0].StrPeres, //体检结果
                            StrEmpUsrStatus:res.msg[0].StrEmpUsrStatus, //人员状态
                            DtInjuryBdate:res.msg[0].DtInjuryBdate, //工伤发生时间
                            StrDisabilityLevel:res.msg[0].StrDisabilityLevel, //伤残等级
                            DtInjuryEdate:res.msg[0].DtInjuryEdate, //自定义项目5
                            StrBlacklist:res.msg[0].StrBlacklist, //是否黑名单
                            StrBlacklistReason:res.msg[0].StrBlacklistReason, //黑名单原因
                            StrRemark:res.msg[0].StrRemark, //备注
                            qudao:res.msg[0].qudao,//招聘渠道
                            sctjr:res.msg[0].sctjr, //社招推荐人
                            gsqd:res.msg[0].gsqd, //公司渠道
                            gsqdtjr:res.msg[0].gsqdtjr, //公司渠道推荐人
                            wbqd:res.msg[0].wbqd, //外部渠道
                            wbqdtjr:res.msg[0].wbqdtjr, //外部渠道推荐人
                            qtqk:res.msg[0].qtqk //其他情况
                        }
                    }
                }
                this.formLoading = false
            })
        },
        //获取省份
        getprovinces(parent) {
            xz.getArea(parent).then(res => {
                // console.log('getprovinces', res)
                if (res.status == 'ok') {
                this.provinces = res.data.ret;
                } else {
                this.provinces = [];
                }
            })
        },
        //获取标签列表
        GetLabelManagement() {
            this.laloading = true;
            this.publicList = []
            this.privateList = []
            xz.GetLabelManagement(this.roleType).then(res => {
                if (res.status == 'ok') {
                this.publicList = res.data.PublicPersonList;
                this.privateList = res.data.PrivatelyList;
                }
                this.laloading = false;
            })
        },
        // 获取简历标签详情
        getresumelabelLists(resumeId){
            this.includePublicChecks = []
            this.includePrivateChecks = []
            xz.GetresumelabelLists({resumeId: resumeId}).then(res => {
                // console.log('getresumelabelLists', res)
                if (res.status == 'ok') {
                    this.lPubDialogList = res.msgpub
                    this.lPriDialogList = res.msgpri
                    // 公共标签
                    if(!this.isNull(res.msgpub)){
                    for (let i = 0; i < res.msgpub.length; i++) {
                        const elementpub = res.msgpub[i];
                        this.includePublicChecks.push(elementpub.LabelId)
                    }
                    }
                    // 私有标签
                    if(!this.isNull(res.msgpri)){
                    for (let j = 0; j < res.msgpri.length; j++) {
                        const elementpri = res.msgpri[j];
                        this.includePrivateChecks.push(elementpri.LabelId)
                    }
                    }
                }
            })
        },
        //判断是否为空(包含0)
        isNull(o) {
            return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == ('1900-01-01') || o == '1900-01-01T00:00:00';
        }
    }
}
</script>

<style>
.r_edit_content .r_spend_box .s_input{
    width: 200px;
}
.r_edit_content .r_spend_box .el-date-editor--daterange.el-input__inner{
    width: 260px!important;
    margin-right: 8px;
}
/* .r_edit_content .el-input.is-disabled .el-input__inner{
    background-color: #fff;
    border: none;
    cursor: default;
}
.r_edit_content .el-input.is-disabled .el-input__icon{
    display: none;
} */
.r_edit_content .p_plan_upload{
    display: flex;
    align-items: center;
}
.r_edit_content .r_spend_box .el-upload-list__item:first-child{
    margin-top: 0;
}
.r_qiwei .el-image__inner{
    width: 30px;
    height: 28px;
    margin-left: 10px;
}
.s_input{
    margin-right: 8px;
}
</style>
<style scoped>
.r_spend_item01{
    display: flex;
    align-items: center;
}
.dlt_icon{
    display: inline-block;
    font-size: 18px;
    color:#999;
    margin-left:10px;
    cursor: pointer;
}
.in_table_box{
    margin-bottom: 10px;
}
.i_info_box{
    margin-top: 10px;
}
.i_info_list{
    display: flex;
    flex-wrap: wrap;
}
.i_info_item{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 17px;
}
.icon_add{
    display: inline-block;
    font-size: 20px;
    color:#409EFF;
    margin-left:10px;
    cursor: pointer;
}
.i_info_left{
    width: 90px;
    color: #7F7F7F;
    font-size: 14px;
}
.i_info_right{
    width: 210px;
    color: #333;
    font-size: 14px;
}
.r_spend_form{
    margin-top: 10px;
    margin-bottom: 20px;
}
.r_btn_box{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
}
.s_file_txt{
    color:#409EFF;
    font-size: 13px;
    margin-left: 5px;
}
.s_content{
    margin-top: 5px;
}
.r_spend_skill{
    display: flex;
    flex-wrap: wrap;
}
.r_spend_btn{
    width: 90px;
}
.r_spend_model{
    position: relative;
    margin-right: 20px;
    display: flex;
    align-items: center;
}
.r_spend_model i{
    position: absolute;
    right: -10px;
    top: -10px;
    font-size: 16px;
    color:#999;
    cursor: pointer;
    z-index: 1;
}
.r_spend_list{
    display: flex;
    /* align-items: center; */
    flex-wrap: wrap;
    margin-bottom: 20px;
}
.r_spend_title{
    font-size: 14px;
    color:#333;
    margin-right: 20px;
    margin-top: 4px;
}
.r_spend_txts{
    display: flex;
    flex-wrap: wrap;
    font-size: 14px;
    color:#333;
    /* flex: 1; */
}
.r_spend_txts span{
    margin-right: 10px;
}
.r_edit_content .r_line_box .el-input{
  width: 98px;
}
.r_line_box{
  display: flex;
  align-items: center;
}
.r_line_txt{
  width: 4px;
  height: 1px;
  background-color: #DCDFE6;
  margin: 0 5px;
}
.r_label_btn{
    width: 90px;
    text-align: right;
}
.r_label_list{
    display: flex;
    flex-wrap: wrap;
}
.r_label_item{
    padding: 2px 10px;
    background-color: #f2f2f2;
    margin-right: 10px;
    margin-bottom: 5px;
}
.r_label_box{
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
}
.r_label_left{
    display: flex;
    /* justify-content: space-between; */
    /* flex: 1; */
}
.l_box{
    flex: 1;
}
.r_label_right{
    width: 150px;
    text-align: center;
}
.r_basic_left{
    flex: 1;
}
.r_basic_right{
    width: 120px;
    text-align: center;
}
.r_basic_box{
    display: flex;
    justify-content: space-between;
}
.r_lefts{
    display: flex;
}
.r_left_info{
    font-size: 14px;
    color: #333;
    margin-left: 20px;
}
.r_txts i{
    font-size: 18px;
    color:#333;
}
.r_txts.r_txts01{
    margin-top: 8px;
}
.r_txt04{
    font-size: 14px;
    color:#000;
    font-weight: bold;
}
.r_txts{
    margin-top: 6px;
}
.r_txt01{
    margin-right: 5px;
}
.r_txt03{
    margin-left: 10px;
}
.r_txt05{
    margin-top: 12px;
    color:#999;
    font-size: 14px;
}
.r_txt06{
    color:#333;
    font-size: 14px;
}
.r_txt07{
    color:#333;
    font-size: 14px;
    margin-bottom: 5px;
}
.r_qiwei{
    display: flex;
    align-items: center;
}
.r_qiwei p{
    font-size: 16px;
    color:#000;
    font-weight: bold;
}
.r_left_pic{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 110px;
    height: 100px
}
.pic_item{
    width: 110px;
    height: 100px
}
.f_form_btn{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-bottom: 1px solid #ddd;
    margin-bottom: 20px;
}
.r_edit_title{
    font-size: 16px;
    line-height: 26px;
    font-weight: bold;
    color:#aaa;
}
</style>